import { FC } from "react";
import { Landing } from "./Components/Landing/Landing";

const App: FC = () => {
  return <><Landing />;</> 
};

export default App;
